import { render, staticRenderFns } from "./ReadingIntent2.vue?vue&type=template&id=4a8dfe04&scoped=true&"
import script from "./ReadingIntent2.vue?vue&type=script&lang=js&"
export * from "./ReadingIntent2.vue?vue&type=script&lang=js&"
import style0 from "./ReadingIntent2.vue?vue&type=style&index=0&id=4a8dfe04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dfe04",
  null
  
)

export default component.exports